import { render, staticRenderFns } from "./TransactionSalesOrderForm.vue?vue&type=template&id=68b18b99&scoped=true&"
import script from "./TransactionSalesOrderForm.vue?vue&type=script&lang=js&"
export * from "./TransactionSalesOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./TransactionSalesOrderForm.vue?vue&type=style&index=0&id=68b18b99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b18b99",
  null
  
)

export default component.exports